import React from 'react';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';
import { AuthContext } from '../../../../shared/context/auth-context';
import { useContext } from 'react';
import './items.css'


const Items = props => {
  const auth = useContext(AuthContext);

  return (
   
    <div className='item-container'> 
      <div className='images-container'>
        <img 
          src={`${process.env.REACT_APP_ASSET_URL}/${props.image}`} 
          alt={props.alt}
        />
      </div> 

      <div className='names-title'>
        
        <div className='names' >
          {props.title}
        </div>
         
        <div className='urls'>
          <NavLink to={`/news/${props.id}`} id='urls-ss'>Цааш нь...</NavLink>
          { auth.isLoggedIn && auth.user && auth.user.role === 'admin' && ( 
            <NavLink to={`/update/${props.id}`} id='edit'>Edit</NavLink>
          )}
        </div>
      </div>
    </div>
  )
}
export default Items;